import { FC, SVGProps } from 'react';

const CustomerAllIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M3.35303 13.6774V6.86373C3.35303 4.4931 4.6694 3.02388 7.08934 3.03128H13.5397C15.9597 3.03128 17.2835 4.50049 17.2835 6.87113V13.6774C17.2835 16.0414 15.9367 17.5172 13.4789 17.5172H7.08934C4.6694 17.5172 3.35303 16.0414 3.35303 13.6774Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.77637 14.1574C7.77637 13.1928 8.53813 11.9906 10.732 11.9906C12.9268 11.9906 13.6886 13.1837 13.6886 14.1492"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.6203 8.27888C12.6203 9.32248 11.7748 10.1672 10.732 10.1672C9.68927 10.1672 8.84375 9.32248 8.84375 8.27888C8.84375 7.23617 9.68927 6.39062 10.732 6.39062C11.7748 6.39062 12.6203 7.23617 12.6203 8.27888Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.08301 7.02185H4.73138M2.08301 13.5237H4.73138"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CustomerAllIcon;
